import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import { mobilePromotion, promotions } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <CFImage src={mobilePromotion} w="100%" alt="Promotions" mt="15px" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center m="10px auto" maxWidth="1400px">
          <CFImage src={promotions} w="98%" alt="Promotions" mt="40px" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
